import { render, staticRenderFns } from "./dialog-add-staff.vue?vue&type=template&id=49b6774e&scoped=true"
import script from "./dialog-add-staff.vue?vue&type=script&lang=js"
export * from "./dialog-add-staff.vue?vue&type=script&lang=js"
import style0 from "./dialog-add-staff.vue?vue&type=style&index=0&id=49b6774e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b6774e",
  null
  
)

export default component.exports